import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
    selector: '[appCheckScroll]'
})
export class CheckScrollDirective {
    @Input() checkLoad: boolean;
    @Input() returnScrollElement: boolean;

    @Output() scrollEmit: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    @HostListener('window:scroll', ['$event'])

    onScroll($event): void {
        $event.preventDefault();
        if (this.returnScrollElement) {
            const item = document.getElementsByTagName('html')[0];
            return this.scrollEmit.emit(item);
        }
        const element = document.getElementsByClassName('wrapper')[0];
        const checkScroll = (element.scrollHeight - element.scrollTop) < (element.clientHeight + 100);
        if (this.checkLoad && checkScroll) {
            this.scrollEmit.emit(true);
        }
    }
}
